import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { client } from '@chegg/pricing-sdk';
import fetchProductRecommendation from './fetchProductRecommendation';
import { toDGSProductType, toGetPricingV2Data } from './product-recommendation-dgs.util';
import { getIsVBCVariation, vbcExperiment } from './experimentation.util';
import { isProd } from '../../common/helper';
import { sendCommerceNewRelicError } from '../NewRelicUtils/index';
import { ProjectName } from './constants';
import { ErrorType } from '../CallbackUtils/constants';
import configureApolloForCommerce from '../../gql/configureApolloForCommerce';
/**
 * VBC pricing by experimentation, allocates user to experiment variations
 * and returns interstitial pricing from the correct system, in the legacy
 * GetPricingV2 format
 * @param apolloClient ApolloClient; one-graph client
 * @param environment Environment; application environment
 * @param inputs GetPricingRequestV2; legacy GetPricingV2 request
 * @param options GetPricingRequestOptions; situational legacy request configuration
 * @returns
 */
export var fetchLatestPricing = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apolloClient, environment, inputs, options, hostname, vbcExperimentData, isRecurly, response, queryInputs, prsResponse, tranformedResponseWithAuthState, _inputs$internalReque;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apolloClient = _ref.apolloClient, environment = _ref.environment, inputs = _ref.inputs, options = _ref.options, hostname = _ref.hostname;
          _context.prev = 1;
          _context.next = 4;
          return vbcExperiment(environment, inputs, hostname);
        case 4:
          vbcExperimentData = _context.sent;
          isRecurly = getIsVBCVariation(vbcExperimentData);
          if (isRecurly) {
            _context.next = 11;
            break;
          }
          _context.next = 9;
          return client.pricingApi.getPricingV2(inputs, options);
        case 9:
          response = _context.sent;
          return _context.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
            isRecurly: false
          }));
        case 11:
          configureApolloForCommerce(isProd(environment), hostname);
          queryInputs = {
            productFamily: [toDGSProductType(inputs.productCode)],
            countryCode: inputs.countryCode
          };
          _context.next = 15;
          return fetchProductRecommendation({
            apolloClient: apolloClient,
            queryInputs: queryInputs
          });
        case 15:
          prsResponse = _context.sent;
          tranformedResponseWithAuthState = toGetPricingV2Data(prsResponse.data, inputs);
          return _context.abrupt("return", {
            data: tranformedResponseWithAuthState,
            success: true,
            errors: null,
            isRecurly: true
          });
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](1);
          sendCommerceNewRelicError({
            error: "Error fetching product recommendation: ".concat(JSON.stringify(_context.t0)),
            componentName: ProjectName,
            componentVersion: '',
            extras: (_inputs$internalReque = inputs.internalRequestPayload) !== null && _inputs$internalReque !== void 0 && _inputs$internalReque.passport ? {
              referrer: inputs.internalRequestPayload.pageUrl || 'server side'
            } : undefined
          });
          return _context.abrupt("return", {
            data: null,
            success: false,
            errors: [{
              message: "Error fetching product recommendation: ".concat(JSON.stringify(_context.t0)),
              type: ErrorType.SERVER,
              code: 'PRSUTIL-000'
            }],
            isRecurly: false
          });
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 20]]);
  }));
  return function fetchLatestPricing(_x) {
    return _ref2.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/fetchLatestPricing.js
// module id = 852
// module chunks = 11